import React from "react";
import AddCategorySitePublisher from "../component/sections/publisher/manage/AddCategorySitePublisher";
import AddSitePublisher from "../component/sections/publisher/manage/AddSitePublisher";
import AllPublisher from "../component/sections/publisher/AllPublisher";
import ManageSitePublisher from "../component/sections/publisher/manage/ManageSitePublisher";
import AllCategoriesSitePublisher from "../component/sections/publisher/manage/AllCategoriesSitePublisher";
import middleware from "./middlewares/middleware";
import EditCategoriesSitePublisher from "../component/sections/publisher/manage/EditCategoriesSitePublisher";
import EditSitePublisher from "../component/sections/publisher/manage/EditSitePublisher";
import AddGroupSitePublisher from "../component/sections/publisher/AddGroupSitePublisher";
import EditGroupPublisher from "../component/sections/publisher/EditGroupPublisher";
import AllGroupUserSitePublisher from "../component/sections/publisher/manage/group-user-site-publisher/AllGroupUserSitePublisher";
import GroupUserSitePublisher from "../component/sections/publisher/manage/group-user-site-publisher/GroupUserSitePublisher";
import AllPagesSitePublisher from "../component/sections/publisher/AllPagesSitePublisher";
import AllPositionsPageSitePublisher from "../component/sections/publisher/AllPositionsPageSitePublisher";
import ReportPosition from "../component/sections/publisher/manage/ReportPosition";
import ReportPositionsReserver from "../component/sections/publisher/ReportPositionsReserver";
import AddGroupSitePublisherContainer from "../component/sections/publisher/AddGroupSitePublisherContainer";
import AllPublisherCoworker from "../component/sections/publisher/coworker/AllPublisher";
import AllCategoryUserSitePublisher from "../component/sections/publisher/coworker/AllCategoryUserSitePublisher";
import AddCategoryUserSitePublisher from "../component/sections/publisher/coworker/AddCategoryUserSitePublisher";
import AddCategoryUserSitePublisherContainer from "../component/sections/publisher/coworker/AddCategoryUserSitePublisherContainer";
import AllPositionsPageSitePublisherCoworker from "../component/sections/publisher/coworker/AllPositionsPageSitePublisherCoworker";
import EditCategoryUserSitePublisherCoworker from "../component/sections/publisher/coworker/EditCategoryUserSitePublisher";
import AllCategoryUserSitePublisherCustomer from "../component/sections/publisher/customer/AllCategoryUserSitePublisher";
import ViewCategoryUserSitePublisherCustomer from "../component/sections/publisher/customer/ViewCategoryUserSitePublisher";
import AllIndependentPositionsSitePublisher from "../component/sections/publisher/AllIndependentPositionsSitePublisher";
import AllIndependentPositionsSitePublisherCoworker from "../component/sections/publisher/coworker/AllIndependentPositionsSitePublisherCoworker";
// import AllPositionsSitePublisherCoworker from "../component/sections/publisher/coworker/AllPositionsSitePublisherCoworker";
import AllCategorySitePublisherAlternative from "../component/sections/publisher/manage/alterenative/AllCategorySitePublisher";
import AddCategorySitePublisherViaCategorySubject from "../component/sections/publisher/manage/alterenative/AddCategorySitePublisherViaCategorySubject";
import AddCategorySitePublisherViaSelectPositions from "../component/sections/publisher/manage/alterenative/AddCategorySitePublisherViaSelectPositions";
import AllPagesSitePublisherAlternative from "../component/sections/publisher/manage/alterenative/AllPagesSitePublisher";
import AllPositionsPageSitePublisherAlternative from "../component/sections/publisher/manage/alterenative/AllPositionsPageSitePublisher";
import AllIndependentPositionsSitePublisherAlternative from "../component/sections/publisher/manage/alterenative/AllIndependentPositionsSitePublisher";
import TypeCategorySitePublisherAlternative from "../component/sections/publisher/manage/alterenative/TypeCategorySitePublisher";
import AllBannerCategorySitePublisherAlternative from "../component/sections/publisher/manage/alterenative/AllCategorySitePublisher";
import EditBannerCategorySitePublisherAlternative from "../component/sections/publisher/manage/alterenative/EditBannerCategorySitePublisher";
import CheckPositionExist from "../component/sections/publisher/manage/CheckPositionExist";
import CheckPositionCampaign from "../component/sections/publisher/manage/CheckPositionCampaign";
import AllPreviewPagesSitePublisher from "../component/sections/publisher/preview/AllPreviewPagesSitePublisher";
import AllPreviewPositionsPageSitePublisher from "../component/sections/publisher/preview/AllPreviewPositionsPageSitePublisher";
import AllPreviewIndependentPositionsSitePublisher from "../component/sections/publisher/preview/AllPreviewIndependentPositionsSitePublisher";
import CheckPositionsHaveDuplicateCampaign from "../component/sections/publisher/manage/CheckPositionsHaveDuplicateCampaign";
import ListCategorySitePublisher from "../component/sections/publisher/ListCategorySitePublisher";
import AddCategorySitePublisherAlternativeViaSelectWebSitePublisher from "../component/sections/publisher/manage/alterenative/AddCategorySitePublisherViaWebSitePublisher";
import AddGroupSitePublisherAutomate from "../component/sections/publisher/AddGroupSitePublisherAutomate";
import AllPagesSitePublisherCoworker from "../component/sections/publisher/coworker/AllPagesSitePublisherCoworker";
import AddGroupSitePublisherAutomateCoworker from "../component/sections/publisher/coworker/AddGroupSitePublisherAutomateCoworker";

const roleRoutes = [
  {
    path: "/publishers/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllPublisher />,
        "AllPublisher"
      );
    },
    exact: true,
  },
  {
    path: "/publishers/list-category-site-publisher",
    render: () => {
      return middleware(
        ["isUserLogin"],
        <ListCategorySitePublisher />,
        "ListCategorySitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/publishers/add-group/banner",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddGroupSitePublisherContainer />,
        "AddGroupSitePublisherContainer"
      );
    },
    exact: true,
  },
  {
    path: "/publishers/add-group-automate/banner",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddGroupSitePublisherAutomate />,
        "AddGroupSitePublisherAutomate"
      );
    },
    exact: true,
  },
  {
    path: "/publishers/coworker/add-group-automate/banner/:userID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddGroupSitePublisherAutomateCoworker />,
        "AddGroupSitePublisherAutomateCoworker"
      );
    },
    exact: true,
  },
  {
    path: "/publishers/edit-group/:typeAdvertise/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <EditGroupPublisher />,
        "EditGroupPublisher"
      );
    },
    exact: true,
  },
  {
    path: "/manage/publishers/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ManageSitePublisher />,
        "ManageSitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/manage/category-publishers/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllCategoriesSitePublisher />,
        "AllCategoriesSitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/manage/publishers/add",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddSitePublisher />,
        "AddSitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/manage/publishers/edit/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <EditSitePublisher />,
        "EditSitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/manage/category-publishers/add",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddCategorySitePublisher />,
        "AddCategorySitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/manage/category-publishers/edit/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <EditCategoriesSitePublisher />,
        "EditCategoriesSitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/manage/category-user-site-publishers/",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllGroupUserSitePublisher />,
        "AllGroupUserSitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/manage/category-user-site-publishers/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <GroupUserSitePublisher />,
        "GroupUserSitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/manage/publishers/report-position",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ReportPosition />,
        "ReportPosition"
      );
    },
    exact: true,
  },
  {
    path: "/manage/publishers/check-position",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <CheckPositionExist />,
        "CheckPositionExist"
      );
    },
    exact: true,
  },
  {
    path: "/manage/publishers/check-position-campaign",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <CheckPositionCampaign />,
        "CheckPositionCampaign"
      );
    },
    exact: true,
  },
  {
    /* id => sitePublisherID*/
    /* categoryUserSitePublisherID => categoryUserSitePublisherID is optional*/
    path: "/publishers/:id/all-page/:categoryUserSitePublisherID?",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllPagesSitePublisher />,
        "AllPagesSitePublisher"
      );
    },
    exact: true,
  },
  {
    /* id => pageID*/
    path: "/publishers/:id/all-positions/",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllPositionsPageSitePublisher />,
        "AllPositionsPageSitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/publishers/:id/all-independent-positions/",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllIndependentPositionsSitePublisher />,
        "AllIndependentPositionsSitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/publishers/display-report-positions",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ReportPositionsReserver />,
        "ReportPositionsReserver"
      );
    },
    exact: true,
  },
  {
    path: "/publishers/coworker/",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllPublisherCoworker />,
        "AllPublisherCoworker"
      );
    },
    exact: true,
  },
  {
    path: "/publishers/coworker/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllCategoryUserSitePublisher />,
        "AllCategoryUserSitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/publishers/coworker/add-group/banner/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddCategoryUserSitePublisherContainer />,
        "AddCategoryUserSitePublisherContainer"
      );
    },
    exact: true,
  },
  {
    /* id => sitePublisherID  */
    /* userID => customerCoworkerID  */
    /* categoryUserSitePublisherID => categoryUserSitePublisherID is optional */
    path: "/publishers/coworker/:id/all-page/:userID/:categoryUserSitePublisherID?",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllPagesSitePublisherCoworker />,
        "AllPagesSitePublisherCoworker"
      );
    },
    exact: true,
  },
  {
    /* id => sitePublisherID  */
    /* userID => customerCoworkerID  */
    /* categoryUserSitePublisherID => categoryUserSitePublisherID is optional */
    path: "/publishers/coworker/:id/all-positions/:userID/:categoryUserSitePublisherID?",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllPositionsPageSitePublisherCoworker />,
        "AllPositionsPageSitePublisherCoworker"
      );
    },
    exact: true,
  },
  {
    /* id => sitePublisherID  */
    /* userID => customerCoworkerID  */
    /* categoryUserSitePublisherID => categoryUserSitePublisherID is optional */
    path: "/publishers/coworker/:id/all-independent-positions/:userID/:categoryUserSitePublisherID?",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllIndependentPositionsSitePublisherCoworker />,
        "AllIndependentPositionsSitePublisherCoworker"
      );
    },
    exact: true,
  },
  {
    path: "/publishers/coworker/edit-group/:typeAdvertise/:id/:userID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <EditCategoryUserSitePublisherCoworker />,
        "EditCategoryUserSitePublisherCoworker"
      );
    },
    exact: true,
  },
  {
    path: "/category-user-site-publisher/customer/",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllCategoryUserSitePublisherCustomer />,
        "AllCategoryUserSitePublisherCustomer"
      );
    },
    exact: true,
  },
  {
    path: "/category-user-site-publisher/customer/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ViewCategoryUserSitePublisherCustomer />,
        "ViewCategoryUserSitePublisherCustomer"
      );
    },
    exact: true,
  },
  {
    path: "/manage/publishers/all-category-site-publisher-alternative",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllCategorySitePublisherAlternative />,
        "AllCategorySitePublisherAlternative"
      );
    },
    exact: true,
  },
  {
    path: "/manage/publishers/add-category-site-publisher-alternative-via-category-subject",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddCategorySitePublisherViaCategorySubject />,
        "AddCategorySitePublisherViaCategorySubject"
      );
    },
    exact: true,
  },
  {
    path: "/manage/publishers/add-category-site-publisher-alternative-via-select-positions",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddCategorySitePublisherViaSelectPositions />,
        "AddCategorySitePublisherViaSelectPositions"
      );
    },
    exact: true,
  },
  {
    /* id => sitePublisherID*/
    /* categoryUserSitePublisherID => categoryUserSitePublisherID is optional*/
    path: "/manage/publishers/alternative/:id/all-page/:categoryUserSitePublisherID?",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllPagesSitePublisherAlternative />,
        "AllPagesSitePublisherAlternative"
      );
    },
    exact: true,
  },
  {
    path: "/manage/publishers/alternative/:id/all-positions",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllPositionsPageSitePublisherAlternative />,
        "AllPositionsPageSitePublisherAlternative"
      );
    },
    exact: true,
  },
  {
    path: "/manage/publishers/alternative/:id/all-independent-positions/",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllIndependentPositionsSitePublisherAlternative />,
        "AllIndependentPositionsSitePublisherAlternative"
      );
    },
    exact: true,
  },
  {
    path: "/manage/publishers/type-category-site-publisher-alternative",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <TypeCategorySitePublisherAlternative />,
        "TypeCategorySitePublisherAlternative"
      );
    },
    exact: true,
  },
  {
    path: "/manage/publishers/all-banner-category-site-publisher-alternative",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllBannerCategorySitePublisherAlternative />,
        "AllBannerCategorySitePublisherAlternative"
      );
    },
    exact: true,
  },
  {
    path: "/publishers/preview/:id/all-page",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllPreviewPagesSitePublisher />,
        "AllPreviewPagesSitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/publishers/preview/:id/all-positions",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllPreviewPositionsPageSitePublisher />,
        "AllPreviewPositionsPageSitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/publishers/preview/:id/all-independent-positions/",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllPreviewIndependentPositionsSitePublisher />,
        "AllPreviewIndependentPositionsSitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/manage/publishers/manage/check-positions-have-duplicate-campaign/",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <CheckPositionsHaveDuplicateCampaign />,
        "CheckPositionsHaveDuplicateCampaign"
      );
    },
    exact: true,
  },
  {
    path: "/manage/publishers/add-category-site-publisher-alternative-via-select-web-site-publisher",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddCategorySitePublisherAlternativeViaSelectWebSitePublisher />,
        "AddCategorySitePublisherAlternativeViaSelectWebSitePublisher"
      );
    },
    exact: true,
  },
];

export default roleRoutes;
